<template>
  <v-row>
      <v-col xs-12>
        <v-card class="mb-2">
          <v-toolbar flat color="secondary" dark>
            <v-icon left>mdi-format-list-bulleted</v-icon>
            <v-toolbar-title>Orders Rows</v-toolbar-title>
          </v-toolbar>
          <BuildRowsList
            :items="model.rows"
            :readOnly="true"
          ></BuildRowsList>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import BuildRowsList from "@components/handling/BuildRowsList.vue";

export default {
    components:{
        BuildRowsList,
    },
    props:{
        value: {
            type:Object,
            require:true
        }
    },
    computed:{
        model:function(){
            return this.value;
        }
    },
}
</script>

<style>

</style>